import classnames from 'classnames'
import React, { FC } from 'react'

import { FilterSection } from '../../../common/types/invoice'
import { t } from '../../i18n'
import { Link } from '../link'

interface Props {
    selected?: FilterSection
}

const pages: FilterSection[] = ['general', 'customer', 'contents']

const renderButton = (page: FilterSection, isSelected: boolean) => (
    <Link
        to={'#/invoices/archive/' + page}
        text={t.revenues.archive.header[page].get()}
        className={classnames(
            'button',
            isSelected ? 'button--transparent-selected' : 'button--transparent',
            'archive__section-button',
        )}
    />
)

export const RevenueArchiveSidebar: FC<Props> = ({ selected }) => (
    <div className="sidebar">
        <h1 className="sidebar__title-with-icon title">
            <img src="/menu/incomes.svg" className="sidebar__title-icon" />
            <div>{t.revenues.archive.get()}</div>
        </h1>
        {pages.map((page) => renderButton(page, page === selected))}
    </div>
)
